import React, { useState } from 'react';
import { Unlock, Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

/** Email gate for an open-access push: one address, no card, no password.
 *  Joins the newsletter, creates the free membership and signs them straight
 *  in so the stories open behind it. */
export const OpenAccessEmailForm = ({ testid = 'open-access', onDone }) => {
  const { joinOpenAccess } = useAuth();
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setError('');
    setBusy(true);
    try {
      await joinOpenAccess(email.trim().toLowerCase());
      if (onDone) onDone();
    } catch (err) {
      setError(err.message || 'Could not unlock. Try again.');
      setBusy(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testid}-form`} className="space-y-3">
      <input
        type="email"
        required
        name="email"
        autoComplete="email"
        inputMode="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="you@email.com"
        data-testid={`${testid}-email`}
        className="w-full bg-black border border-zinc-700 focus:border-red-500 rounded px-4 py-3 text-sm text-white outline-none placeholder:text-zinc-600 transition-colors"
      />
      <button
        type="submit"
        disabled={busy}
        data-testid={`${testid}-submit`}
        className="w-full inline-flex items-center justify-center gap-2 bg-red-600 hover:bg-red-500 disabled:opacity-60 text-white font-black text-xs uppercase tracking-[0.25em] px-5 py-3.5 rounded transition-colors"
      >
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Unlock className="h-4 w-4" />}
        {busy ? 'Unlocking…' : 'Unlock every story'}
      </button>
      {error && (
        <p data-testid={`${testid}-error`} className="text-red-400 text-xs">{error}</p>
      )}
      <p className="text-[11px] text-zinc-500 leading-relaxed">
        Your email joins the Outlaw list and sets up your free membership. No card, no password.
        Unsubscribe any time.
      </p>
    </form>
  );
};

export default OpenAccessEmailForm;
